import { hasImageInput, extractImageFrames, clampTo } from '../../tools';
import type { coolModelConfig } from '../types';

export const minimaxConfigs: Record<string, coolModelConfig> = {
    'hailuo-h3': {
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, videoUri, videoUris, audioUri, audioUris, aspectRatio, duration, quality, modelUi } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage, lastImage] = extractImageFrames(imagePrompt);
            const images = (imagePrompt ?? []).filter(Boolean).slice(0, 9);
            const allMedia = [
                ...((videoUris?.length ?? 0) > 0 ? videoUris! : videoUri ? [videoUri] : []).filter(Boolean).map(url => ({ type: 'video' as const, url })),
                ...((audioUris?.length ?? 0) > 0 ? audioUris! : audioUri ? [audioUri] : []).filter(Boolean).map(url => ({ type: 'audio' as const, url })),
            ].slice(0, 3);
            const videos = allMedia.filter(m => m.type === 'video').map(m => m.url);
            const audios = allMedia.filter(m => m.type === 'audio').map(m => m.url);
            // 首帧模式
            if (frameMode === 'first') {
                    return {
                        model: 'minimax_h3',
                        prompt: `[system: 首帧使用 @图片1][prompt: ${prompt}]`,
                        ratio: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '1:1', '21:9'] as const, '16:9'),
                        duration: clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                        resolution: clampTo((quality || '768p').toLowerCase(), ['480p', '720p', '768p', '1080p', '2k'] as const, '768p'),
                        // 首帧 URL
                        files: [
                            {
                                url: firstImage!,
                                type: "image",
                                name: "图片1",
                            },
                        ],
                        // system
                        optimizePromptAsync: false,
                    };
            // 首尾帧模式
            } else if (frameMode === 'first_last') {
                    return {
                        model: 'minimax_h3',
                        prompt:
                        `[system: 首帧使用 @图片1${!!lastImage ? ', 尾帧使用 @图片2' : ''}][prompt: ${prompt}]`,
                        ratio: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '1:1', '21:9'] as const, '16:9'),
                        duration: clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                        // resolution: clampTo((quality || '768p').toLowerCase(), ['480p', '720p', '768p', '1080p', '2k'] as const, '768p'),
                        // 首尾帧 URL
                        files: [
                            {
                                url: firstImage!,
                                type: "image",
                                name: "图片1",
                            },
                            {
                                url: lastImage!,
                                type: "image",
                                name: "图片2",
                            },
                        ],
                        // system
                        optimizePromptAsync: false,
                    };
            // 参考模式
            } else if (frameMode === 'ref') {
                return {
                    model: 'minimax_h3',
                    prompt: prompt,
                    ratio: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '1:1', '21:9'] as const, '16:9'),
                    duration: clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                    resolution: clampTo((quality || '768p').toLowerCase(), ['480p', '720p', '768p', '1080p', '2k'] as const, '768p'),
                    // 参考 URL
                    files: [
                        ...images.map(url => ({
                            url: url,
                            type: "image",
                        })),
                        ...videos.map(url => ({
                            url: url,
                            type: "video",
                        })),
                        ...audios.map(url => ({
                            url: url,
                            type: "audio",
                        })),
                    ],
                    // system
                    optimizePromptAsync: false,
                };
            // 文生视频模式
            } else {
                return {
                    model: 'minimax_h3',
                    prompt: prompt,
                    ratio: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '1:1', '21:9'] as const, '16:9'),
                    duration: clampTo(duration || 5, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                    resolution: clampTo((quality || '768p').toLowerCase(), ['480p', '720p', '768p', '1080p', '2k'] as const, '768p'),
                    // system
                    optimizePromptAsync: false,
                };
            }
        },
    },
};